import { render, staticRenderFns } from "./MaterialListAccessories.vue?vue&type=template&id=403a14dc&"
import script from "./MaterialListAccessories.vue?vue&type=script&lang=js&"
export * from "./MaterialListAccessories.vue?vue&type=script&lang=js&"
import style0 from "./MaterialListAccessories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports